import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=54b5057d&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b5057d')) {
      api.createRecord('54b5057d', component.options)
    } else {
      api.reload('54b5057d', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=54b5057d&", function () {
      api.rerender('54b5057d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/components/Footer.vue"
export default component.exports